import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { Avatar, Button, ButtonLink, Card, Dialog, Flex, Heading, ProgressIndicator, Text } from '@applyboard/crystal-ui';
import { ApplicationActionName } from "../../../../types";
import { useRecommendedPrograms } from "../../data/recommendedPrograms";
import { BuildingFillIcon, CircleCrossHifiIcon } from '@applyboard/ui-icons';
import { useApplicationAvailableActions, useApplicationConfiguration, useApplicationEslIntake, useApplicationMainProgram, useApplicationMainSchool } from "../../data";
import { convertTimelessDateStrToLocalDate } from "../../../../utils/dates";
import { ProgramType, useApplication, useLegacyApplication } from "../../data/application";
import { ColorIndicator } from "../../../../components/ColorIndicator";
import { CreateApplicationButton } from "../../../../components/CreateApplicationButton";
import { useEventTracker } from '@applyboard/ui-utils';
import { EmptyState } from "./EmptyState";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var RecommendedProgramsDialog = function RecommendedProgramsDialog(props) {
  var _mainIntake$seatAvail, _mainIntake$seatAvail2, _props$triggerSetting, _props$triggerSetting2, _props$triggerSetting3;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationMainPr = useApplicationMainProgram(),
    mainProgramDetails = _useApplicationMainPr.mainProgramDetails,
    mainIntake = _useApplicationMainPr.mainIntake;
  var _useApplicationMainSc = useApplicationMainSchool(),
    mainSchool = _useApplicationMainSc.mainSchool;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  var _useApplicationEslInt = useApplicationEslIntake(),
    eslIntake = _useApplicationEslInt.eslIntake;
  var isAvailable = canPerformApplicationAction(ApplicationActionName.RECOMMENDED_PROGRAM);
  var _useEventTracker = useEventTracker({
      data: {
        programId: mainProgramDetails.id,
        programLevel: mainProgramDetails.level,
        schoolId: mainSchool.id,
        schoolCountry: mainSchool.countryCode,
        score: mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail = mainIntake.seatAvailability) === null || _mainIntake$seatAvail === void 0 ? void 0 : _mainIntake$seatAvail.score,
        scoreLevel: mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail2 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail2 === void 0 ? void 0 : _mainIntake$seatAvail2.determination,
        currentAcademicIntake: mainIntake === null || mainIntake === void 0 ? void 0 : mainIntake.startDate,
        currentESLIntake: eslIntake === null || eslIntake === void 0 ? void 0 : eslIntake.startDate,
        origin: props.origin
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  return _jsx(_Fragment, {
    children: _jsxs(Dialog, {
      open: props.isOpen,
      onOpenChange: function onOpenChange(openStatus) {
        props.onOpenChange(openStatus);
        if (!openStatus) {
          trackEvent({
            event: 'Single Application - Recommended Programs - Dismissed Modal By Clicking Away OR X'
          });
        }
      },
      size: isAvailable ? 'lg' : 'md',
      children: [!((_props$triggerSetting = props.triggerSettings) !== null && _props$triggerSetting !== void 0 && _props$triggerSetting.hide) && isAvailable ? _jsx(Dialog.Trigger, {
        children: _jsx(Button, {
          width: props.width,
          emphasis: ((_props$triggerSetting2 = props.triggerSettings) === null || _props$triggerSetting2 === void 0 ? void 0 : _props$triggerSetting2.emphasis) || 'outlined',
          size: (_props$triggerSetting3 = props.triggerSettings) === null || _props$triggerSetting3 === void 0 ? void 0 : _props$triggerSetting3.size,
          intent: "primary",
          onClick: props.onClick,
          children: "See recommended programs"
        })
      }) : _jsx(_Fragment, {}), _jsx(Dialog.Heading, {
        children: "Recommended Programs"
      }), _jsx(Dialog.Content, {
        children: _jsx(RecommendedProgramsDialogContent, {
          application: application,
          onDetailsClick: function onDetailsClick() {
            return props.onOpenChange(false);
          },
          trackEvent: trackEvent,
          origin: props.origin
        })
      }), !isAvailable && _jsx(Dialog.Actions, {
        children: _jsx(Button, {
          intent: "primary",
          width: "fill",
          onClick: function onClick() {
            return props.onOpenChange(false);
          },
          children: "OK"
        })
      })]
    })
  });
};
function RecommendedProgramsDialogContent(_ref) {
  var trackEvent = _ref.trackEvent,
    application = _ref.application,
    _onDetailsClick = _ref.onDetailsClick,
    origin = _ref.origin;
  var _useRecommendedProgra = useRecommendedPrograms({
      useCase: getUseCaseFromOrigin(origin)
    }),
    recommendedPrograms = _useRecommendedProgra.recommendedPrograms,
    isLoadingRecommendedPrograms = _useRecommendedProgra.isLoadingRecommendedPrograms,
    recommendedProgramsMeta = _useRecommendedProgra.recommendedProgramsMeta;
  var _useApplicationAvaila2 = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila2.canPerformApplicationAction;

  // eslint-disable-next-line no-restricted-syntax -- TODO: change this to use useTrackViewEvent
  useEffect(function () {
    // Track the event only once when isLoadingRecommendedPrograms is not true
    if (!isLoadingRecommendedPrograms) {
      trackEvent({
        event: 'Single Application - Recommended Programs - Started',
        data: {
          programs: recommendedPrograms === null || recommendedPrograms === void 0 ? void 0 : recommendedPrograms.map(function (program) {
            return {
              recommendedProgramId: program.program.id,
              recommendedProgramScore: program.seatAvailability.score,
              recommendedProgramIntake: program.startDate,
              recommendedProgramSchoolId: program.school.id,
              recommendedProgramSchoolCountry: program.school.country
            };
          }),
          ruleProfileName: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileName,
          ruleProfileVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileVersion,
          successScoreVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.successScoreVersion
        }
      });
    }
  }, [isLoadingRecommendedPrograms, recommendedPrograms, recommendedProgramsMeta, trackEvent]);
  var isAvailable = canPerformApplicationAction(ApplicationActionName.RECOMMENDED_PROGRAM);
  if (isLoadingRecommendedPrograms) {
    return _jsx(Flex, {
      align: "center",
      justify: "center",
      pt: 4,
      children: _jsx(ProgressIndicator, {
        size: "lg",
        label: "Loading...",
        variant: "circular",
        indeterminate: true
      })
    });
  }
  if (!isAvailable) {
    return _jsxs(Flex, {
      gap: 5,
      children: [_jsx(CircleCrossHifiIcon, {
        intent: "negative"
      }), _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(Text, {
          children: "Sorry, it looks like you don't have permission to see this."
        }), _jsx(Text, {
          children: "Please reach out to your ApplyBoard representative if you have any questions."
        })]
      })]
    });
  }
  if (recommendedPrograms.length === 0) {
    return _jsxs(Flex, {
      direction: "column",
      children: [_jsx(IntroductionMessage, {}), _jsx(EmptyState, {})]
    });
  }
  return _jsxs(Flex, {
    direction: "column",
    children: [_jsx(IntroductionMessage, {}), _jsx(Flex, {
      direction: "column",
      pt: 4,
      gap: 4,
      children: recommendedPrograms.map(function (recommendedProgram, idx) {
        return _jsx(RecommendedProgramsCard, {
          recommendedProgram: recommendedProgram,
          student: application.student,
          onDetailsClick: function onDetailsClick() {
            _onDetailsClick();
            trackEvent({
              event: 'Single Application - Recommended Programs - Clicked See Program Details',
              data: {
                recommendedProgramId: recommendedProgram.program.id,
                recommendedProgramScore: recommendedProgram.seatAvailability.score,
                recommendedProgramIntake: recommendedProgram.startDate,
                recommendedProgramSchoolId: recommendedProgram.school.id,
                recommendedProgramSchoolCountry: recommendedProgram.school.country,
                programs: recommendedPrograms === null || recommendedPrograms === void 0 ? void 0 : recommendedPrograms.map(function (program) {
                  return {
                    recommendedProgramId: program.program.id,
                    recommendedProgramScore: program.seatAvailability.score,
                    recommendedProgramIntake: program.startDate,
                    recommendedProgramSchoolId: program.school.id,
                    recommendedProgramSchoolCountry: program.school.country
                  };
                }),
                ruleProfileName: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileName,
                ruleProfileVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileVersion,
                successScoreVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.successScoreVersion
              }
            });
          },
          onCreateApplicationClick: function onCreateApplicationClick() {
            trackEvent({
              event: 'Single Application - Recommended Programs - Clicked Create application',
              data: {
                recommendedProgramId: recommendedProgram.program.id,
                recommendedProgramScore: recommendedProgram.seatAvailability.score,
                recommendedProgramIntake: recommendedProgram.startDate,
                recommendedProgramSchoolId: recommendedProgram.school.id,
                recommendedProgramSchoolCountry: recommendedProgram.school.country,
                programs: recommendedPrograms === null || recommendedPrograms === void 0 ? void 0 : recommendedPrograms.map(function (program) {
                  return {
                    recommendedProgramId: program.program.id,
                    recommendedProgramScore: program.seatAvailability.score,
                    recommendedProgramIntake: program.startDate,
                    recommendedProgramSchoolId: program.school.id,
                    recommendedProgramSchoolCountry: program.school.country
                  };
                }),
                ruleProfileName: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileName,
                ruleProfileVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.ruleProfileVersion,
                successScoreVersion: recommendedProgramsMeta === null || recommendedProgramsMeta === void 0 ? void 0 : recommendedProgramsMeta.successScoreVersion
              }
            });
          }
        }, idx);
      })
    })]
  });
}
function IntroductionMessage() {
  return _jsx(Text, {
    children: "Below is a curated list of recommended programs. Click \"See program details\" to learn more. To create a new application without impacting your current one, click \"Create Application\"."
  });
}
var RecommendedProgramsCard = function RecommendedProgramsCard(props) {
  var _school$logo, _currentProgram$id, _mainIntake$seatAvail3, _mainIntake$seatAvail4, _legacyApplication$pr, _legacyApplication$pr2;
  var _props$recommendedPro = props.recommendedProgram,
    seatAvailability = _props$recommendedPro.seatAvailability,
    school = _props$recommendedPro.school,
    program = _props$recommendedPro.program,
    startDate = _props$recommendedPro.startDate,
    intakeId = _props$recommendedPro.intakeId;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplicationMainPr2 = useApplicationMainProgram(),
    currentProgram = _useApplicationMainPr2.mainProgramDetails,
    mainIntake = _useApplicationMainPr2.mainIntake;
  var _useApplicationMainSc2 = useApplicationMainSchool(),
    currentSchool = _useApplicationMainSc2.mainSchool;
  if (!school || !program) {
    return null;
  }
  return _jsxs(Card, {
    as: "article",
    children: [_jsxs(Flex, {
      align: "center",
      wrap: false,
      gap: 2,
      children: [_jsx(SuccessScoreCardText, {
        seatAvailability: seatAvailability
      }), _jsx(Text, {
        children: "\u2022"
      }), _jsx(IntakeCardText, {
        startDate: props.recommendedProgram.startDate
      })]
    }), _jsxs(Flex, {
      gap: 4,
      py: 4,
      children: [_jsx(Flex.Item, {
        children: (_school$logo = school.logo) !== null && _school$logo !== void 0 && _school$logo.url ? _jsx(Avatar, {
          image: school.logo.url,
          alt: school.name
        }) : _jsx(Avatar, {
          icon: BuildingFillIcon
        })
      }), _jsxs(Flex.Item, {
        children: [_jsx(Text, {
          variant: "labelL",
          children: school.name
        }), _jsx(Heading, {
          level: 2,
          children: program.name
        }), _jsx(Text, {
          children: program.levelText
        })]
      })]
    }), _jsxs(Flex, {
      gap: 2,
      direction: {
        xs: 'column',
        sm: 'row'
      },
      children: [_jsx(Flex.Item, {
        basis: "50%",
        children: _jsx(ButtonLink, {
          emphasis: "outlined",
          intent: "primary",
          href: "/schools/".concat(school.slug, "/programs/").concat(program.slug),
          mode: "override_user_choice_and_open_in_new_tab",
          width: "fill",
          onClick: props.onDetailsClick,
          children: "See program details"
        })
      }), _jsx(Flex.Item, {
        basis: "50%",
        children: _jsx(CreateApplicationButton, {
          program: {
            id: program.id,
            name: program.name,
            programLevel: program.level
          },
          currentProgram: {
            id: currentProgram === null || currentProgram === void 0 ? void 0 : (_currentProgram$id = currentProgram.id) === null || _currentProgram$id === void 0 ? void 0 : _currentProgram$id.toString(),
            programLevel: currentProgram === null || currentProgram === void 0 ? void 0 : currentProgram.level,
            successScore: mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail3 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail3 === void 0 ? void 0 : _mainIntake$seatAvail3.score,
            successScoreLevel: mainIntake === null || mainIntake === void 0 ? void 0 : (_mainIntake$seatAvail4 = mainIntake.seatAvailability) === null || _mainIntake$seatAvail4 === void 0 ? void 0 : _mainIntake$seatAvail4.determination,
            academicIntake: (_legacyApplication$pr = legacyApplication.programs.find(function (program) {
              return program.programType === ProgramType.Main;
            })) === null || _legacyApplication$pr === void 0 ? void 0 : _legacyApplication$pr.intake.startDate,
            eslIntake: (_legacyApplication$pr2 = legacyApplication.programs.find(function (program) {
              return program.programType === ProgramType.Esl;
            })) === null || _legacyApplication$pr2 === void 0 ? void 0 : _legacyApplication$pr2.intake.startDate
          },
          currentSchool: {
            id: currentSchool === null || currentSchool === void 0 ? void 0 : currentSchool.id,
            country: currentSchool === null || currentSchool === void 0 ? void 0 : currentSchool.countryCode
          },
          school: {
            id: school.id,
            country: school.country
          },
          student: {
            name: props.student.fullName,
            id: props.student.id.toString()
          },
          selectedIntake: {
            intakeId: intakeId,
            startDate: startDate,
            warningInsights: []
          },
          pageName: "Application Page",
          onClick: props.onCreateApplicationClick,
          buttonEmphasis: "contained",
          buttonWidth: "fill",
          hideIcon: true
        })
      })]
    })]
  });
};
var IntakeCardText = function IntakeCardText(_ref2) {
  var startDate = _ref2.startDate;
  return _jsxs(Text, {
    children: [format(convertTimelessDateStrToLocalDate(startDate), 'LLL yyyy'), " Intake"]
  });
};
var SuccessScoreCardText = function SuccessScoreCardText(_ref3) {
  var seatAvailability = _ref3.seatAvailability;
  var _useApplicationConfig = useApplicationConfiguration(),
    applicationConfiguration = _useApplicationConfig.applicationConfiguration;
  return _jsxs(Flex, {
    gap: 2,
    align: "center",
    children: [_jsx(Flex.Item, {
      children: _jsx(ColorIndicator, {
        colorCode: getColorCode(seatAvailability, applicationConfiguration)
      })
    }), _jsxs(Text, {
      children: [seatAvailability.determination, " (", seatAvailability.score, "%) Success Score"]
    })]
  });
};
function getColorCode(seatAvailability, applicationConfiguration) {
  var _applicationConfigura;
  return applicationConfiguration === null || applicationConfiguration === void 0 ? void 0 : (_applicationConfigura = applicationConfiguration.applicationSuccessScoreLevels.find(function (score) {
    return score.level === seatAvailability.determination;
  })) === null || _applicationConfigura === void 0 ? void 0 : _applicationConfigura.colorCode;
}
function getUseCaseFromOrigin(origin) {
  var useCase = undefined;
  switch (origin) {
    case 'self-serve':
      useCase = 'app-page-self-serve-menu';
      break;
    case 'ats':
      useCase = 'app-page-app-journey-stepper';
      break;
    case 'insights card':
      useCase = 'app-page-recommendation-button';
      break;
    case 'hash url':
      useCase = 'app-page-notes';
      break;
  }
  return useCase;
}